import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import { getDateValue } from '../../utils/date';
import { DateField } from './schedule_utils';
import { adjustmentReasons } from '../../constants';

const FMT = 'MM/DD/YYYY';

const adjustmentReasonOptions = adjustmentReasons.map(reason => {
  return {
    value: reason,
    label: reason,
  }
});


function addDays (start, num) {
  return moment(getDateValue(start), FMT).add(num, 'days').format(FMT);
}


class AdjustForm extends React.Component {
  // static PropTypes = {
  //   value: PropTypes.string.isRequired,
  //   newValue: PropTypes.string.isRequired,
  //   existing: PropTypes.object.isRequired,
  //   limits: PropTypes.object.isRequired,
  //   onSubmit: PropTypes.func.isRequired,
  //   hasClientDate: PropTypes.bool.isRequired,
  // }

  constructor (props) {
    super(props);

    const state = {
      newDate: '',
      delay: 0,
      reason: '',
      clientDays: 0,
      ...props.existing,
    }

    if (props.newValue) {
      state.newDate = getDateValue(props.newValue);
      state.delay = this.getDelay(getDateValue(props.newValue));
    }

    this.state = state;

    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleDaysChange = this.handleDaysChange.bind(this)
    this.handleDateChange = this.handleDateChange.bind(this)
    this.handleReasonChange = this.handleReasonChange.bind(this)
  }

  handleDateChange (newDate) {
    this.setState({
      delay: this.getDelay(newDate),
      newDate
    });
  }

  handleDaysChange (e) {
    const clientDays = parseInt(e.target.value, 10);
    this.setState({ clientDays });
  }

  handleReasonChange (option) {
    const reason = option ? option.value : '';
    this.setState({ reason });
  }

  handleSubmit (e) {
    e.preventDefault();
    let clientDate = null;
    const { newDate, reason, clientDays } = this.state;

    if (newDate && reason) {
      if (clientDays) {
        clientDate = addDays(this.props.value, clientDays)
      }
      this.props.onSubmit(newDate, reason, clientDays, clientDate);
    }
  }

  getDelay (date) {
    if (!date) return 0;
    const oldValue = moment(getDateValue(this.props.value), FMT);
    const newValue = moment(date, FMT);
    return newValue.diff(oldValue, 'days');
  }

  renderClientDayError () {
    const { delay, clientDays } = this.state;
    if (delay && clientDays && clientDays > delay) {
      return <span className="error">Please enter a valid value.</span>
    }
  }

  renderDelay (delay) {
    return delay ? <strong className="delay">{delay} Day Delay</strong> : null;
  }

  render () {
    const { newValue } = this.props;
    const { newDate, delay, reason, clientDays } = this.state;

    let canSubmit = ( newDate && reason && delay !== 0);
    if (clientDays && clientDays > delay) canSubmit = false;
    if (this.props.hasClientDate) canSubmit = canSubmit && clientDays;

    return (
      <form className="modal-form" onSubmit={this.handleSubmit}>
        <div className="control">
          <label>Current projected date</label>
          <strong>{getDateValue(this.props.value)}</strong>
        </div>

        <div className={'control' + (newValue ? '' : ' required')}>
          <label>{newValue ? 'Actual' : ' New projected'} date</label>
          { newValue
            ? <strong>{newDate}</strong>
            : <DateField
                value={newDate}
                limits={this.props.limits}
                onChange={this.handleDateChange}
              />
          }
          {this.renderDelay(delay)}
        </div>

        <div className="control required">
          <label>Reason for {newValue ? 'delay' : 'adjustment'}</label>
          <Select name="documentType"
            value={this.state.reason}
            options={adjustmentReasonOptions}
            onChange={this.handleReasonChange}
          />
        </div>

        { this.props.hasClientDate
          ? <div className="control required">
              <label>Number of days attributable to client</label>
              <input type="number" name="clientDays" min='0'
                value={this.state.clientDays}
                onChange={this.handleDaysChange} />
              {this.renderClientDayError()}
            </div>
          : null }
        <button className="btn-update" disabled={canSubmit <'0'}>Update</button>
      </form>
    )
  }
}

AdjustForm.propTypes = {
  value: PropTypes.string.isRequired,
  newValue: PropTypes.string.isRequired,
  existing: PropTypes.object.isRequired,
  limits: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  hasClientDate: PropTypes.bool.isRequired
};

export default AdjustForm;